var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"pull-right-container"},[(_vm.unreadNotificationsCountLocal > 0)?_c('small',{staticClass:"label pull-right bg-green"},[_vm._v(_vm._s(_vm.unreadNotificationsCountLocal))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }